<script>

import {API_PAY} from '../../common/api'
import MyPagination from '../../components/MyPagination'
import DatePicker from '../../components/DatePicker'
import UserPayUpdate from './UserPayUpdate'
import BaseList from '../BaseList'
import {statusEnum, statusOptions, methodEnum, methodOptions} from '../../assets/js/common'

export default {
  name: 'UserPayList',
  extends: BaseList,
  data() {
    return {
      searchForm: {
        searchKey: '',
        method: '',
        status: '',
        start_date: '',
        end_date: ''
      },
      operateUserNumber: '',
      operateUserName: '',
      userId: this.$store.state.home.user_obj.id,
      statusEnum,
      statusOptions,
      methodEnum,
      methodOptions
    }
  },
  created() {
    this.tableHeight = window.innerHeight - 150;
    if (this.userId === 3) {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      this.searchForm.start_date = `${year}-${month}-01`
      const day = now.getDate().toString().padStart(2, '0')
      this.searchForm.end_date = `${year}-${month}-${day}`
      this.currentPage = 1
      this.getDataList()
    }
  },
  methods: {
    getDataList() {
      this.loading = true
      let params = {
        page_no: this.currentPage,
        page_num: this.pageSize,
        search_key: this.searchForm.searchKey,
        method: this.searchForm.method,
        status: this.searchForm.status,
        start_date: this.searchForm.start_date,
        end_date: this.searchForm.end_date
      }
      this.$http.GET(API_PAY, params,
        res => {
          this.loading = false
          this.tableData = res.result.list
          this.totalCount = res.result.total
        }, err => {
          this.loading = false
          this.$message.error(err.msg)
        })
    },
    datePickerChange(obj) {
      this.searchForm.start_date = obj.start_date
      this.searchForm.end_date = obj.end_date
      this.currentPage = 1
      this.getDataList()
    },
    deleteUserPay(userPayId) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.DELETE(API_PAY+ '/' + userPayId, null,
          res => {
            this.getDataList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }, err => {
            this.$message.error(err.msg)
          })
      }).catch(() => {
      });
    }
  },
  components: {
    MyPagination,
    DatePicker,
    UserPayUpdate
  }
}
</script>

<template>
  <div>
    <div class="search_section">
      <el-form :inline="true" :model="searchForm" size="small" @submit.native.prevent>
        <el-form-item class="search_item">
          <el-input v-model="searchForm.searchKey" placeholder="用户编号/姓名/手机号" clearable></el-input>
        </el-form-item>
        <el-form-item class="search_item">
          <el-select v-model="searchForm.method" clearable placeholder="缴费方式" @change="searchData">
            <el-option
              v-for="item in this.methodOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search_item">
          <el-select v-model="searchForm.status" clearable placeholder="操作内容" @change="searchData">
            <el-option
              v-for="item in this.statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="userId !== 3" class="search_item search_date_picker">
          <date-picker @datePickerChange="datePickerChange"></date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchData">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{background: '#eef1f6', color: '#606266'}"
      highlight-current-row
      size="small"
      :height="tableHeight"
      border
      style="padding: 5px;">
      <el-table-column label="用户编号" prop="number"></el-table-column>
      <el-table-column label="用户名" prop="user_name"></el-table-column>
      <el-table-column label="所属小区" prop="village_name"></el-table-column>
      <el-table-column label="上次表底" prop="last_amount"></el-table-column>
      <el-table-column label="本次表底" prop="now_amount"></el-table-column>
      <el-table-column label="用水量" prop="use_amount"></el-table-column>
      <el-table-column label="水费" prop="money"></el-table-column>
      <el-table-column label="水资源税" prop="tax"></el-table-column>
      <el-table-column label="实收水费" prop="real_money"></el-table-column>
      <el-table-column label="账户余额" prop="balance"></el-table-column>
      <el-table-column label="内容">
        <template slot-scope="{row}">
          {{ methodEnum[row.method] }}{{ statusEnum[row.status] }}
        </template>
      </el-table-column>
      <el-table-column label="时间" prop="create_time" width="180px"></el-table-column>
      <el-table-column label="操作" align="center" width="160px">
        <template slot-scope="{row}">
          <el-tooltip class="operate_item" effect="dark" content="修改" placement="top">
            <i class="iconfont icon-bianji operate_font" @click="showUpdate(row.id)"></i>
          </el-tooltip>
          <el-tooltip class="operate_item" effect="dark" content="删除" placement="top">
            <i class="iconfont icon-shanchu operate_font" @click="deleteUserPay(row.id)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <MyPagination :totalCount="totalCount" :currentPage="currentPage" @handleSizeChange="handleSizeChange"
                  @handleCurrentChange="handleCurrentChange"></MyPagination>

    <el-dialog
      title="修改用户缴费信息"
      v-if="updateDialogVisible"
      :visible="updateDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body='true'
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="updateDialogVisible = false">
      <UserPayUpdate :pay_id='operateId' @closeUpdate="updateDialogVisible = false"
                       @updateSuccess="updateSuccess"></UserPayUpdate>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>

@import '../../assets/styles/table.scss';

.search_date_picker {
  padding-top: 1px;

  .date_picker {
    width: 250px;
  }
}

</style>



// WEBPACK FOOTER //
// src/page/user/UserPayList.vue